import styled from 'styled-components';

import cssWrapper from '@spotnana/pixel-react/dist/utils/cssWrapper';
import spotnanaTheme from '@spotnana/pixel-react/dist/utils/themes/theme';

import { ExpandButtonVariant } from './types';

interface IButtonProps {
  expanded: boolean;
  variant: ExpandButtonVariant;
}

const transformConfig = (expanded: IButtonProps['expanded'], variant: IButtonProps['variant']): string => {
  if (variant === 'side') {
    return expanded ? 'rotate(90deg)' : 'rotate(0deg)';
  }

  return expanded ? 'rotate(180deg)' : 'rotate(0deg)';
};

export const Button = styled.button<IButtonProps>(
  cssWrapper({
    width: 24,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'bg.white',
    border: 'thin solid',
    borderColor: 'border.disabled',
    borderRadius: 'xs',
    cursor: 'pointer',
    ':disabled': {
      backgroundColor: spotnanaTheme.colors.bg.brightGrey,
    },
  }),
  (props) => ({
    transform: transformConfig(props.expanded, props.variant),
  }),
);
